import { request } from "services/api/util";

class TermsAndConditionsService {
  async getListTermsAndConditions() {
    const config = {
      method: "get",
      url: `admin/termsAndConditions`,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getDetailTermsAndConditions(id) {
    const config = {
      method: "get",
      url: `admin/termsAndConditions/${id}`,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async updateTermsAndConditions(body, id) {
    const config = {
      method: "put",
      url: `admin/termsAndConditions/${id}`,
      data: body,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
}

export default new TermsAndConditionsService();
